import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
/**
 * External dependencies
 */

/**
 * Internal dependencies
 */
import { VStack } from '../../v-stack';
export const Wrapper = /*#__PURE__*/_styled(VStack, process.env.NODE_ENV === "production" ? {
  target: "e1p5onf00"
} : {
  target: "e1p5onf00",
  label: "Wrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1khn195",
  styles: "box-sizing:border-box"
} : {
  name: "1khn195",
  styles: "box-sizing:border-box/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFVdUMiLCJmaWxlIjoic3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBFeHRlcm5hbCBkZXBlbmRlbmNpZXNcbiAqL1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG4vKipcbiAqIEludGVybmFsIGRlcGVuZGVuY2llc1xuICovXG5pbXBvcnQgeyBWU3RhY2sgfSBmcm9tICcuLi8uLi92LXN0YWNrJztcblxuZXhwb3J0IGNvbnN0IFdyYXBwZXIgPSBzdHlsZWQoIFZTdGFjayApYFxuXHRib3gtc2l6aW5nOiBib3JkZXItYm94O1xuYDtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});